import Reflux from 'reflux';
import urlHandlerActions from './urlHandlerActions';
import { findIndex } from 'underscore';
import { createHistory, useQueries } from 'history';
import clone from 'clone';

const history = useQueries(createHistory)();
let { searchArray } = window;
const UrlHandlerStore = Reflux.createStore({
  listenables: urlHandlerActions,
  init() {
    this.allData = {};
    history.listen((location) => {
      this.allData = location.query;
    });

    this.itemSearch = [];
    let hash = '';
    const hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');
    for (let i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      const temp = {};
      if (hash[0].length !== 0) {
        temp.key = hash[0];
        temp.value = hash[1];
        this.itemSearch.push(hash[1]);
        // searchArray.push(temp);
      }
    }
  },
  processData(data) {
    // Taxonomies handling
    ReactiveFanoutData.urlData = data;
    let finalQueryString = '';
    if (data.searchType === 'taxonomies' || data.searchType === 'metakeys' || data.searchType === 'globalSearch') {
      this.allData[data.searchItem] = [];
      const newValues = [];
      switch (data.searchField) {
        case 'mapField':
          let popIndexMap = findIndex(searchArray, { key: data.searchItem });
          if (popIndexMap !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexMap].value);
            this.itemSearch.splice(index, 1);
            searchArray.splice(popIndexMap, 1);
          }
          this.allData[data.searchItem] = data.values;
          const tempMap = {};
          popIndexMap = findIndex(searchArray, { key: data.searchItem });
          if (popIndexMap !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexMap].value);
            this.itemSearch.splice(index, 1);
            searchArray.splice(popIndexMap, 1);
          }
          tempMap.key = data.searchItem;
          tempMap.value = data.values;
          this.itemSearch.push(data.values);
          searchArray.push(tempMap);
          const popIndexPageMap = findIndex(searchArray, { key: 'pagenumber' });
          if (popIndexPageMap !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexPageMap].value);
            if (index !== -1) {
              this.itemSearch.splice(index, 1);
              searchArray.splice(index, 1);
            }
          }
          const tempPageMap = {};
          tempPageMap.key = 'pagenumber';
          tempPageMap.value = 1;
          this.itemSearch.push(tempPageMap.value);
          searchArray.push(tempPageMap);
          break;
        case 'topListOrGrid':
          if (data.values.length === 1) {
            newValues[0] = data.values[0];
          }
          this.allData[data.searchItem] = newValues;
          const popIndexForViewType = findIndex(searchArray, { key: data.searchItem });
          if (popIndexForViewType !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexForViewType].value);
            this.itemSearch.splice(index, 1);
            searchArray.splice(popIndexForViewType, 1);
          }
          const tempForViewType = {};
          tempForViewType.key = data.searchItem;
          tempForViewType.value = newValues[0];
          this.itemSearch.push(newValues[0]);
          searchArray.push(tempForViewType);
          const popIndexPageView = findIndex(searchArray, { key: 'pagenumber' });
          if (popIndexPageView !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexPageView].value);
            if (index !== -1) {
              this.itemSearch.splice(index, 1);
              searchArray.splice(index, 1);
            }
          }
          const tempPageView = {};
          tempPageView.key = 'pagenumber';
          tempPageView.value = 1;
          this.itemSearch.push(tempPageView.value);
          searchArray.push(tempPageView);
          break;
        case 'pagination':
          if (data.pageNumber) {
            newValues[0] = data.pageNumber;
          }
          this.allData[data.searchItem] = newValues;
          const popIndexForPagination = findIndex(searchArray, { key: data.searchItem });
          if (popIndexForPagination !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexForPagination].value);
            this.itemSearch.splice(index, 1);
            searchArray.splice(popIndexForPagination, 1);
          }
          const tempForPagination = {};
          tempForPagination.key = data.searchItem;
          tempForPagination.value = newValues[0];
          this.itemSearch.push(newValues[0]);
          searchArray.push(tempForPagination);
          break;
        case 'daterange':
          if (data.values.length === 2) {
            newValues.push(data.values[0]);
            newValues.push(data.values[1]);
          }
          delete this.allData[data.searchItem];
          delete this.allData[data.searchItem + '[start]'];
          delete this.allData[data.searchItem + '[end]'];
          if (newValues.length === 2) {
            this.allData[data.searchItem + '[start]'] = newValues[0];
            this.allData[data.searchItem + '[end]'] = newValues[1];
            const tempForStart = {};
            tempForStart.metakey = data.searchItem;
            tempForStart.key = data.searchItem + '[start]';
            tempForStart.value = newValues[0];
            const tempForEnd = {};
            tempForEnd.key = data.searchItem + '[end]';
            tempForEnd.metakey = data.searchItem;
            tempForEnd.value = newValues[1];
            const popIndexForStart = findIndex(searchArray, { key: tempForStart.key });
            const popIndexForEnd = findIndex(searchArray, { key: tempForEnd.key });
            if (popIndexForEnd !== -1) {
              searchArray.splice(popIndexForEnd, 1);
              this.itemSearch.splice(popIndexForEnd, 1);
            }
            if (popIndexForStart !== -1) {
              searchArray.splice(popIndexForStart, 1);
              this.itemSearch.splice(popIndexForStart, 1);
            }
            searchArray.push(tempForStart);
            searchArray.push(tempForEnd);
            this.itemSearch.push(newValues[0]);
            this.itemSearch.push(newValues[1]);
          }
          const popIndexPageDRange = findIndex(searchArray, { key: 'pagenumber' });
          if (popIndexPageDRange !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexPageDRange].value);
            if (index !== -1) {
              this.itemSearch.splice(index, 1);
              searchArray.splice(index, 1);
            }
          }
          const tempPageDRange = {};
          tempPageDRange.key = 'pagenumber';
          tempPageDRange.value = 1;
          this.itemSearch.push(tempPageDRange.value);
          searchArray.push(tempPageDRange);
          break;
        case 'searchAttrTopBar':
          if (data.viewType === 'rangeinput') {
            const index = findIndex(searchArray, { 'metakey': data.rangeKey });
            searchArray.splice(index + 1, 1);
            this.itemSearch.splice(index + 1, 1);
            searchArray.splice(index, 1);
            this.itemSearch.splice(index, 1);
          } else if (data.viewType === 'rnb-daterange') {
            let endIndex = null;
            let startIndex = null;
            for (let i = 0; i < searchArray.length; i++) {
              if (searchArray[i].key.indexOf('[end]') !== -1) {
                endIndex = i;
              }
              if (searchArray[i].key.indexOf('[start]') !== -1) {
                startIndex = i;
              }
            }
            if (startIndex > endIndex) {
              searchArray.splice(startIndex, 1);
              this.itemSearch.splice(startIndex, 1);
              searchArray.splice(endIndex, 1);
              this.itemSearch.splice(endIndex, 1);
            } else {
              searchArray.splice(endIndex, 1);
              this.itemSearch.splice(endIndex, 1);
              searchArray.splice(startIndex, 1);
              this.itemSearch.splice(startIndex, 1);
            }
          } else if (data.viewType === 'daterange') {
            let endIndex = null;
            let startIndex = null;
            for (let i = 0; i < searchArray.length; i++) {
              if (searchArray[i].key.indexOf('[end]') !== -1) {
                endIndex = i;
              }
              if (searchArray[i].key.indexOf('[start]') !== -1) {
                startIndex = i;
              }
            }
            if (startIndex > endIndex) {
              searchArray.splice(startIndex, 1);
              this.itemSearch.splice(startIndex, 1);
              searchArray.splice(endIndex, 1);
              this.itemSearch.splice(endIndex, 1);
            } else {
              searchArray.splice(endIndex, 1);
              this.itemSearch.splice(endIndex, 1);
              searchArray.splice(startIndex, 1);
              this.itemSearch.splice(startIndex, 1);
            }
          } else if (data.viewType === 'combobox') {
            const index = findIndex(searchArray, { value: data.value });
            searchArray.splice(index, 1);       // remove the item that's being clicked on topbar
            this.itemSearch.splice(index, 1);
            const findParentOfChild = () => {         // Recursive function to find the parent of children
              this.itemSearch.map((item, itemIndex) => {
                const index1 = findIndex(data.linearData, { slug: item }); // find the item index in liniear array
                let index2 = '';
                if (index1 !== -1) {
                  index2 = findIndex(data.linearData, { key: data.linearData[index1].parent });  // find the items parent index in linear array
                }
                if (index2 !== '') {
                  if (index2 !== -1) {
                    const index3 = _.indexOf(this.itemSearch, data.linearData[index2].slug);  // search the parent item is available on itemsearch array or not
                    if (index3 === -1) {   // if the parent of child item is not available than remove it from array
                      searchArray.splice(itemIndex, 1);
                      this.itemSearch.splice(itemIndex, 1);
                      findParentOfChild(this.itemSearch);
                    }
                  }
                }
              });
            };
            findParentOfChild();
          } else {
            const searchArrayTemp = clone(searchArray);
            searchArrayTemp.map((popItem, popIndex) => {
              if (popItem.key === data.key && popItem.value === data.value) {
                searchArray.splice(popIndex, 1);
                this.itemSearch.splice(popIndex, 1);
              }
            });
            // const index = findIndex(searchArray, { value: data.value });
          }
          const popIndexPageTopBar = findIndex(searchArray, { key: 'pagenumber' });
          if (popIndexPageTopBar !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexPageTopBar].value);
            if (index !== -1) {
              this.itemSearch.splice(index, 1);
              searchArray.splice(index, 1);
            }
          }
          const tempPageTopBar = {};
          tempPageTopBar.key = 'pagenumber';
          tempPageTopBar.value = 1;
          this.itemSearch.push(tempPageTopBar.value);
          searchArray.push(tempPageTopBar);
          break;
        case 'rangeInput':
          // console.log(data);
          data.values.forEach((item) => {
            for (const key in item) {
              if (item.hasOwnProperty(key)) {
                newValues.push(item[key]);
              }
            }
          });
          // console.log(this.allData);
          // console.log(this.itemSearch);
          delete this.allData[data.searchItem];
          delete this.allData[data.searchItem + '[min]'];
          delete this.allData[data.searchItem + '[max]'];
          if (newValues.length === 2) {
            this.allData[data.searchItem + '[min]'] = newValues[0];
            this.allData[data.searchItem + '[max]'] = newValues[1];
            const tempForMin = {};
            tempForMin.key = data.searchItem + '[min]';
            tempForMin.metakey = data.searchItem;
            tempForMin.value = newValues[0];
            tempForMin.metakey = data.searchItem;
            const tempForMax = {};
            tempForMax.key = data.searchItem + '[max]';
            tempForMax.metakey = data.searchItem;
            tempForMax.value = newValues[1];
            tempForMax.metakey = data.searchItem;
            const popIndexForMin = findIndex(searchArray, { key: tempForMin.key });
            const popIndexForMax = findIndex(searchArray, { key: tempForMax.key });
            if (popIndexForMax !== -1) {
              searchArray.splice(popIndexForMax, 1);
              this.itemSearch.splice(popIndexForMax, 1);
            }
            if (popIndexForMin !== -1) {
              searchArray.splice(popIndexForMin, 1);
              this.itemSearch.splice(popIndexForMin, 1);
            }
            searchArray.push(tempForMin);
            searchArray.push(tempForMax);
            this.itemSearch.push(newValues[0]);
            this.itemSearch.push(newValues[1]);
          }
          const popIndexPageRange = findIndex(searchArray, { key: 'pagenumber' });
          if (popIndexPageRange !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexPageRange].value);
            if (index !== -1) {
              this.itemSearch.splice(index, 1);
              searchArray.splice(index, 1);
            }
          }
          const tempPageRange = {};
          tempPageRange.key = 'pagenumber';
          tempPageRange.value = 1;
          this.itemSearch.push(tempPageRange.value);
          searchArray.push(tempPageRange);
          break;
        case 'textbox':
          if (data.values.length === 0) {
            const popIndex = findIndex(searchArray, { key: data.searchItem });
            if (popIndex !== -1) {
              const index = _.indexOf(this.itemSearch, searchArray[popIndex].value);
              this.itemSearch.splice(index, 1);
              searchArray.splice(popIndex, 1);
            }
            break;
          }
          this.allData[data.searchItem] = data.values;
          const temp = {};
          const popIndex = findIndex(searchArray, { key: data.searchItem });
          if (popIndex !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndex].value);
            this.itemSearch.splice(index, 1);
            searchArray.splice(popIndex, 1);
          }
          temp.key = data.searchItem;
          temp.value = data.values;
          this.itemSearch.push(data.values);
          searchArray.push(temp);
          const popIndexPagetextBox = findIndex(searchArray, { key: 'pagenumber' });
          if (popIndexPagetextBox !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexPagetextBox].value);
            if (index !== -1) {
              this.itemSearch.splice(index, 1);
              searchArray.splice(index, 1);
            }
          }
          const tempPageText = {};
          tempPageText.key = 'pagenumber';
          tempPageText.value = 1;
          this.itemSearch.push(tempPageText.value);
          searchArray.push(tempPageText);
          break;
        case 'comboBox':
          data.values.forEach((item) => {
            if (item.slug) {
              newValues.push(item.slug);
            }
          });
          this.allData[data.searchItem] = newValues;
          const comboOptions = [];
          this.itemSearch.map((singleItem) => {
            const Index = findIndex(data.options, { slug: singleItem });
            if (Index !== -1) {
              comboOptions.push(singleItem);
            }
          });
          let tempOptions = [];
          // new item is checked
          if (newValues.length > comboOptions.length) {
            tempOptions = _.difference(newValues, comboOptions);
            tempOptions.map((singleItem) => {
              const tempCombo = {};
              tempCombo.key = data.searchItem;
              tempCombo.value = singleItem;
              this.itemSearch.push(singleItem);
              searchArray.push(tempCombo);
            });
          } else { // Checked item is unchecked
            tempOptions = _.difference(comboOptions, newValues);
            tempOptions.map((item) => {
              const index = _.indexOf(this.itemSearch, item);
              if (index !== -1) {
                this.itemSearch.splice(index, 1);
                searchArray.splice(index, 1);
              }
            });
          }
          const popIndexPageCombo = findIndex(searchArray, { key: 'pagenumber' });
          if (popIndexPageCombo !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexPageCombo].value);
            if (index !== -1) {
              this.itemSearch.splice(index, 1);
              searchArray.splice(index, 1);
            }
          }
          const tempPageCombo = {};
          tempPageCombo.key = 'pagenumber';
          tempPageCombo.value = 1;
          this.itemSearch.push(tempPageCombo.value);
          searchArray.push(tempPageCombo);
          break;
        default:
          data.values.forEach((item) => {
            if (item.slug) {
              newValues.push(item.slug);
            }
          });
          this.allData[data.searchItem] = newValues;
          const searchItem = data.searchItem;
          data.values.forEach((item) => {
            let insertNewValue = true;
            if (item.slug) {
              for (let i = 0; i < searchArray.length; i++) {
                if (searchArray[i].key === data.searchItem && item.slug === searchArray[i].value) {
                  insertNewValue = false;
                }
              }
              if (insertNewValue === true) {
                const teampDefault = {};
                teampDefault.key = searchItem;
                teampDefault.value = item.slug;
                this.itemSearch.push(item.slug);
                searchArray.push(teampDefault);
              }
            }
          });
          const tempSearchArray = clone(searchArray);
          tempSearchArray.map((popItem, tempPopIndex) => {
            if (popItem.key === data.searchItem) {
              if (this.allData[data.searchItem].indexOf(popItem.value) === -1) {
                this.itemSearch.splice(tempPopIndex, 1);
                searchArray.splice(tempPopIndex, 1);
              }
            }
          });
          const popIndexPage = findIndex(searchArray, { key: 'pagenumber' });
          if (popIndexPage !== -1) {
            const index = _.indexOf(this.itemSearch, searchArray[popIndexPage].value);
            if (index !== -1) {
              this.itemSearch.splice(index, 1);
              searchArray.splice(index, 1);
            }
          }
          const tempPage = {};
          tempPage.key = 'pagenumber';
          tempPage.value = 1;
          this.itemSearch.push(tempPage.value);
          searchArray.push(tempPage);
          break;
      }
      finalQueryString = '?';
    } else {
      this.allData = {};
      finalQueryString = '';
      searchArray = window.searchArray = [];
      this.itemSearch = [];
    }
    searchArray.forEach((searchAttr) => {
      if (finalQueryString.length === 1) {
        finalQueryString += searchAttr.key + '=' + searchAttr.value;
      } else {
        finalQueryString += '&' + searchAttr.key + '=' + searchAttr.value;
      }
    });
    history.push({ 'pathname': location.pathname, 'search': finalQueryString, 'query': '' });
    this.trigger({ query: this.allData });
  },
  onProcess(data) {
    // for changing the event , everyone will use this path
    // this.allData.push(data);
    if (data.searchItem === 'view') {
      window.doAjax = false;
      window.loadPageNumber = 'nochange';
      jQuery('#LoadTime').fadeOut(300);
    } else {
      window.doAjax = true;
      window.loadPageNumber = 'change';
    }
    this.processData(data);
    // maybe will use http request in here
   // this.trigger({ query : this.allData });
  },
});

export default UrlHandlerStore;



// WEBPACK FOOTER //
// ./assets/src/frontend/urlhandler/urlHandlerStore.js